import { render } from "./MaTinees.vue?vue&type=template&id=1c640fcc&scoped=true&ts=true"
import script from "./MaTinees.vue?vue&type=script&lang=ts"
export * from "./MaTinees.vue?vue&type=script&lang=ts"

import "./MaTinees.vue?vue&type=style&index=0&id=1c640fcc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c640fcc"]])

export default __exports__